import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseReviewPublicCompanyLeadProps {
  id?: string
  state?: string
  onSuccess: () => void
  onError: () => void
}

export const useReviewPublicCompanyLead = ({ id, state, onSuccess, onError }: UseReviewPublicCompanyLeadProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['reviewPublicCompanyLead'],
    mutationFn: async (data?: { description?: string }) => {
      const lead = {
        last_review_attributes: {
          state,
          description: data?.description,
        },
      }

      await privateAxios.put(`/funnel/public/leads/${id}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
